import { Link } from "@tanstack/react-router";

import { ScreenSpinner } from "@/components";
import { useProfile } from "@/domains/profile/queries/use-profile";
import { focusRingInset, icons } from "@/ui";
import { MyAccountDisplayText } from "./my-account-display-text";

export const BasicInformationListItems = () => {
  const { data: profile } = useProfile();

  if (!profile) {
    return <ScreenSpinner className="pt-0" />;
  }

  const infoItems = [
    { title: "Email address", value: profile.email },
    { title: "First name", value: profile.firstName },
    { title: "Last name", value: profile.lastName },
    { title: "Date of birth", value: profile.displayBirthDate },
    { title: "Mobile phone number", value: profile.phone },
  ];

  return (
    <section className="flex size-full flex-col overflow-auto pr-4 pb-6 sm:pr-0">
      <div className="flex w-full flex-col gap-1 pt-4 sm:w-fit sm:min-w-112.5 sm:gap-4">
        {infoItems.map((item) => {
          return <MyAccountDisplayText key={item.title} title={item.title} value={item.value} />;
        })}

        {!profile.isPersonify && (
          <Link
            className={`group mt-3 flex w-full cursor-pointer flex-row items-center justify-between gap-4 rounded-card px-3 py-4 transition-colors hover:bg-surface-hover hover:text-accent sm:mt-0 sm:py-3 ${focusRingInset}`}
            search={{ tab: "change-password" }}
            to="/more"
          >
            <div className="flex flex-row items-center gap-4">
              <div className="rounded-full bg-canvas p-2">
                <icons.LockPasswordUnlocked className="size-4" />
              </div>

              <span>Change password</span>
            </div>

            <icons.ChevronRightIcon
              aria-hidden="true"
              className="size-5 shrink-0 stroke-content-muted transition-transform duration-200 group-hover:translate-x-1 group-hover:stroke-accent"
            />
          </Link>
        )}
      </div>
    </section>
  );
};
